import Experience from "@folio-2026/experience"
import Resources from "@folio-2026/resources"
import { EVENTS } from "@folio-2026/shared"
import gsap from "gsap"
import { color, positionGeometry, uniform, vec4 } from "three/tsl"
import * as THREE from "three/webgpu"
import { UniformNode } from "three/webgpu"

import { RENDER_ORDER } from "./const"

export default class Curtain {
  experience: Experience

  curtainAlpha: UniformNode<number>
  mesh: THREE.Mesh
  resources: Resources
  private promisesResolved: boolean = false
  private clickFired: boolean = false

  constructor({
    scene,
    resources,
  }: {
    scene: THREE.Object3D
    resources: Resources
  }) {
    this.experience = Experience.getInstance()

    this.resources = resources

    this.curtainAlpha = uniform(1)

    const geometry = new THREE.PlaneGeometry(2, 2)
    const material = new THREE.MeshBasicNodeMaterial({ transparent: true })
    material.vertexNode = vec4(positionGeometry.x, positionGeometry.y, 0, 1)

    material.colorNode = color("black")
    material.opacityNode = this.curtainAlpha
    material.depthWrite = false
    material.depthTest = false

    this.mesh = new THREE.Mesh(geometry, material)
    this.mesh.renderOrder = RENDER_ORDER.CURTAIN

    this.mesh.position.z = -1

    scene.add(this.mesh)

    this.experience.on(EVENTS.Loader.AllSectionsUpdated, () => {
      this.promisesResolved = true
      this.activateEnterCTA()
      this.checkAndRemoveCurtain()
    })

    // Listen for click event
    this.experience.on(
      EVENTS.Loader.EnterCTA.Click,
      this.onClickHandler.bind(this),
    )
  }

  activateEnterCTA() {
    const enterCTA = document.getElementById("enter-cta")
    if (enterCTA) {
      enterCTA.removeAttribute("disabled")
    }
  }

  onClickHandler() {
    this.clickFired = true
    this.checkAndRemoveCurtain()
  }

  checkAndRemoveCurtain() {
    // Only remove curtain if both conditions are met
    if (this.promisesResolved && this.clickFired) {
      this.removeCurtain()
    }
  }

  removeCurtain() {
    const loaderWrapper = document.getElementById("tcmg-loader-wrapper")
    const loaderText = document.getElementById("tcmg-loader-text")

    this.experience.trigger(EVENTS.Loader.CurtainStartedRemoving)

    if (loaderWrapper) {
      gsap.to(loaderWrapper, {
        opacity: 0,
        duration: 1,
        ease: "expo.in",
        onComplete: () => {
          loaderWrapper.remove()
        },
      })
    }

    if (loaderText) {
      gsap.to(loaderText, {
        opacity: 0,
        duration: 1,
        ease: "expo.in",
        onComplete: () => {
          loaderText.remove()
        },
      })
    }

    gsap.to(this.curtainAlpha, {
      value: 0,
      duration: 1,
      ease: "expo.in",
      onComplete: () => {
        this.experience.trigger(EVENTS.Loader.CurtainRemoved)
      },
    })
  }
}
